import AuthService from '../services/auth.service';
import AdminService from '/src/modules/systemAdmin/admin.service';
// src\services\auth.service.js
// src\modules\admin\admin.service.js
const user = JSON.parse(localStorage.getItem('user'));
const userAppModule = JSON.parse(localStorage.getItem('userAppModule'));  // admin
const userAppIndex = 0;
const initialState = user
  ? { status: { loggedIn: true }, user, userAppModule, userAppIndex}
  : { status: { loggedIn: false }, user: null, userAppModule: null , userAppIndex};

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    userAppIndex({ commit }, userAppIndex) {
      commit('userAppIndex',  userAppIndex);
    },
    moduleIn({ commit }, moduleId) {
      return AdminService.moduleIn(this.state.auth.user.id, moduleId).then(
        userAppModule => {
          commit('moduleInSuccess', userAppModule);
          return Promise.resolve(userAppModule);
        },
        error => {
          commit('moduleInFailure');
          return Promise.reject(error);
        }
      );
    },
    moduleOut({ commit }) {
      AdminService.moduleOut();
      commit('moduleOut');
    },
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    }
  },
  mutations: {
    userAppIndex(state, userAppIndex) {
      state.userAppIndex = userAppIndex;
    },
    moduleInSuccess(state, userAppModule) {
      state.userAppModule = userAppModule;
    },
    moduleInFailure(state) {
      state.userAppModule = null;
    },
    moduleOut(state) {
      state.userAppModule = null;
    },
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
      state.userAppModule = null;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
      state.userAppModule = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
      state.userAppModule = null;
      state.userAppIndex = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    }
  }
};
